export default __webpack_public_path__ + "static/right-side-img-fcd3647c1b6a2475e4833eeda363fc6c.png";